import { selectBadgeCount } from '@alternativamais/chat-core';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import { avisarErro } from '../componentes/Avisos';
import { useCliente, useEstado } from '../chat/contexto';
import { AtualizacaoPronta } from './AtualizacaoPronta';
import { type EstadoAtualizacao, imagemDoBadge, ponteDesktop } from './ponte';

const STATUS = new Set(['online', 'idle', 'dnd', 'invisible']);

/**
 * O que o app para computador faz com o chat aberto: contador no ícone,
 * status da bandeja nos dois sentidos, links (deep link e notificação) e o
 * aviso de versão nova pronta. No navegador não faz nada.
 */
export function DesktopNoChat() {
  const ponte = ponteDesktop();
  const cliente = useCliente();
  const navegar = useNavigate();
  const naoLidas = useEstado(selectBadgeCount);
  const status = useEstado((estado) => estado.userSettings?.status ?? 'online');
  const [pronta, setPronta] = useState<Extract<
    EstadoAtualizacao,
    { fase: 'pronta' }
  > | null>(null);
  const [dispensada, setDispensada] = useState<string | null>(null);

  useEffect(() => {
    if (!ponte) return;
    ponte.badge(naoLidas, naoLidas ? imagemDoBadge(naoLidas) : undefined);
  }, [ponte, naoLidas]);

  useEffect(() => {
    ponte?.status(status);
  }, [ponte, status]);

  useEffect(() => {
    if (!ponte) return;
    const pararStatus = ponte.aoStatus((novo) => {
      if (STATUS.has(novo)) {
        cliente
          .setStatus(novo as 'online' | 'idle' | 'dnd' | 'invisible')
          .catch(avisarErro);
      }
    });
    const pararLinks = ponte.aoNavegar((rota) => navegar(rota));
    const mostrar = (estado: EstadoAtualizacao | null) =>
      setPronta(estado?.fase === 'pronta' ? estado : null);
    void ponte.atualizacao.estado().then(mostrar);
    const pararAtualizacao = ponte.atualizacao.aoMudar(mostrar);
    return () => {
      pararStatus();
      pararLinks();
      pararAtualizacao();
    };
  }, [ponte, cliente, navegar]);

  if (!ponte || !pronta || dispensada === pronta.versao) return null;
  return (
    <AtualizacaoPronta
      versao={pronta.versao}
      notas={pronta.notas}
      aoReiniciar={() => ponte.atualizacao.reiniciar()}
      aoFechar={() => setDispensada(pronta.versao)}
    />
  );
}
